import { createSlice } from "@reduxjs/toolkit";
import { getRawMaterialList } from "../../reduxApi/admin/RawMaterialApi";

const rawMaterialSlice = createSlice({
    name: 'rawMaterial',
    initialState: {
        status: 'idel',
        isFiltered: false,
        rawMaterial: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteRawMaterialAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.rawMaterial.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.rawMaterial.splice(index, 1);
                }
            });
        },

        updateRawMaterialAction: (state, action) => {
            const index = state.rawMaterial.findIndex((item) => item.ROWID === action.payload.ROWID);
            if (index !== -1) {
                state.rawMaterial.splice(index, 1, { rawMaterial: action.payload });
            }
        },
        addRawMaterialAction: (state, action) => {
            console.log("action--->", action.payload);
            const temp = action.payload;
            console.log("temp", temp);
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID", temp.ROWID);
            state.rawMaterial.unshift({ rawMaterial: temp }); // add new data at beginning of array
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getRawMaterialList.pending, (state, action) => {
            state.status = 'pending';
        })
        .addCase(getRawMaterialList.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.rawMaterial = action.payload?.data || action.payload;
        })
        .addCase(getRawMaterialList.rejected, (state, action) => {
            state.status = 'rejected';
        });
    }
});

export const { 
    deleteRawMaterialAction, 
    updateRawMaterialAction, 
    addRawMaterialAction, 
    setFilteredStatus 
} = rawMaterialSlice.actions;

export default rawMaterialSlice.reducer;